import type { Category } from './types';

export const categories: Category[] = [
  {
    id: 'video',
    name: '免费视频',
    icon: 'ri-movie-2-line',
    description: '精选电影、纪录片、动漫与公开课，随时免费观看。',
    subCategories: [
      { id: 'film', name: '电影精选' },
      { id: 'short', name: '短片动画' },
      { id: 'doc', name: '纪录片' },
      { id: 'anime', name: '动漫番剧' },
      { id: 'open', name: '公开课' },
    ],
  },
  {
    id: 'software',
    name: '免费软件',
    icon: 'ri-apps-2-line',
    description: '覆盖效率、设计、系统与开发工具，安全免费下载。',
    subCategories: [
      { id: 'office', name: '办公效率' },
      { id: 'design', name: '设计创作' },
      { id: 'system', name: '系统工具' },
      { id: 'media', name: '影音播放' },
      { id: 'dev', name: '开发工具' },
    ],
  },
  {
    id: 'tutorial',
    name: '实用教程',
    icon: 'ri-book-open-line',
    description: '编程、设计、办公与生活技能，循序渐进轻松上手。',
    subCategories: [
      { id: 'code', name: '编程开发' },
      { id: 'design-tut', name: '设计教程' },
      { id: 'office-skill', name: '办公技能' },
      { id: 'language', name: '语言学习' },
      { id: 'life', name: '生活兴趣' },
    ],
  },
];

export const subCategoryLabels: Record<string, string> = {
  film: '电影精选',
  short: '短片动画',
  doc: '纪录片',
  anime: '动漫番剧',
  open: '公开课',
  office: '办公效率',
  design: '设计创作',
  system: '系统工具',
  media: '影音播放',
  dev: '开发工具',
  code: '编程开发',
  'design-tut': '设计教程',
  'office-skill': '办公技能',
  language: '语言学习',
  life: '生活兴趣',
};